export default (message, translation) => {
    switch (message) {
    case 'Request failed with status code 500':
        return translation.ERROR_MESSAGE_SERVER_ERROR;
    case 'Request failed with status code 401':
        return translation.ERROR_MESSAGE_UNAUTHORIZED;
    default:
        return message;
    }
};
